import { onMounted } from 'vue'

export const useCloudinaryUpload = (lesson, onSuccess, onError) => {
  const cloudName = 'dttzs5jxf'
  const uploadPreset = 'lesson_media'

  let uploadWidget = null

  /**
   * Initialize the upload widget when component mounts
   */
  const initializeUploadWidget = () => {
    // Skip if already initialized
    if (uploadWidget) return

    // Load Cloudinary Upload Widget script
    if (!window.cloudinary) {
      const script = document.createElement('script')
      script.src = 'https://upload-widget.cloudinary.com/latest/global/all.js'
      script.onload = () => createUploadWidget()
      script.onerror = () => {
        console.error('❌ Failed to load Cloudinary script')
        onError?.('Failed to load upload widget')
      }
      document.head.appendChild(script)
    } else {
      createUploadWidget()
    }
  }

  /**
   * Create the upload widget with configuration
   */
  const createUploadWidget = () => {
    const widgetConfig = {
      cloudName,
      uploadPreset,
      multiple: true,
      resourceType: 'auto',
      clientAllowedFormats: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'mp4', 'mov', 'avi', 'wmv'],
      maxFileSize: 50000000, // 50MB
      maxVideoFileSize: 1000000000, // 1GB for videos
      folder: `lessons/${lesson.id}`,
      context: {
        lessonId: lesson.id,
        studentId: lesson.studentId,
        instructorId: lesson.instructorId,
        studentName: lesson.student?.name,
        instructorName: lesson.instructor?.name,
        date: lesson.date,
      },
      showPoweredBy: false,
      theme: 'minimal',
    }

    uploadWidget = window.cloudinary.createUploadWidget(widgetConfig, handleUploadCallback)
  }

  /**
   * Handle upload widget callbacks
   */
  const handleUploadCallback = (error, result) => {
    if (error) {
      console.error('❌ Upload error:', error)
      onError?.('Upload failed. Please try again.')
      return
    }

    if (!result || !result.event) return

    if (result.event === 'success') {
      onSuccess?.(result.info)
    }
  }

  /**
   * Open the upload widget
   */
  const openUploadWidget = () => {
    if (uploadWidget) {
      uploadWidget.open()
    } else {
      console.error('❌ Upload widget not initialized')
      onError?.('Upload widget not ready')
    }
  }

  onMounted(() => {
    initializeUploadWidget()
  })

  return {
    openUploadWidget,
  }
}
